module.exports = __webpack_public_path__ + "media/Flutey Phone.7dd71f0b.ogg";